import withActiveCallAnimation from '../hoc/withActiveCallAnimation';
import withStartOutboundCall from '../hoc/withStartOutboundCall';
import CallButton from './CallButton';
import React, { useCallback } from 'react';

function CallButtonContainer({ onCallPhone, phone, ...props }) {
  const onClick = useCallback(() => {
    if (phone && phone.id) {
      onCallPhone(phone.id);
    }
  }, [onCallPhone, phone]);

  return <CallButton {...props} phone={phone} onClick={onClick} />;
}

export default withStartOutboundCall(
  withActiveCallAnimation(CallButtonContainer)
);
